var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"friend-links"},[_c('ArticleOtherLinks',{attrs:{"links":_vm.friendLinks,"titleImage":{
      src: 'friend-link',
      alt: _vm.articleTitle,
      mode: 'medium',
      target: 'blank',
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }